import { DialogService, GridAction } from '@eforall/dashboard';
import { AccLead } from '@interfaces';
import { PersonDialog, PersonDialogData } from '../../../../../../ui/widget';
import { AssignedStaffDialog, AssignedStaffDialogResult, EntrepreneurProspectDialog } from '../../../../../../ui/widget/dialog';
import { AdmissionsAreaService } from '../../../../admissions-area.service';

export function getActions(dialogService: DialogService, admissionsAreaService: AdmissionsAreaService) {

	const actions: GridAction<AccLead>[] = [
		{
			iconClass: 'fa-regular fa-filter-list',
			label: 'View Prospect Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(EntrepreneurProspectDialog, { data: { personId: rows[0]!.personId, accProspectId: rows[0]!.accProspectId } }, 900, 750);
				await admissionsAreaService.reloadData(); // TODO reload data only if there is a change
			}
		},
		{
			iconClass: 'fa-regular fa-user',
			label: 'Explore Person',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-message-arrow-up-right',
			label: 'View All Engagements',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const dialogData: PersonDialogData = { personId: rows[0]!.personId, toEdit: false, tab: 'engagements' };
				await dialogService.showCustom(PersonDialog, { data: dialogData }, 800, 800);
			}
		},
		{
			iconClass: 'fa-regular fa-user-plus',
			label: 'Assign Staff Member',
			isEnabled: rows => {
				if (admissionsAreaService.canManageAdmissionsStaff()) return !!rows.length;
				return false;
			},
			execute: async rows => {
				const leadName = rows[0]?.fullName;
				const staffId = rows[0]?.assignedToStaffId || 0;
				const action = await dialogService.showCustom(AssignedStaffDialog, {
					data: {
						headerText: leadName!,
						staffId: staffId
					}
				}, 800, 300);

				const result = action?.callbackResult as AssignedStaffDialogResult | undefined;
				if (result) {
					await admissionsAreaService.updateAssignedStaffForLead(rows[0]!.accLeadId, result.staffId);
					await admissionsAreaService.reloadData();
				}
			}
		},
	];

	return actions;
}